import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { Toaster } from 'sonner'
import Header from '../components/Header'
import type { RouteContext } from '@tanstack/react-router'
import TanStackQueryLayout from '@/integrations/tanstack-query/layout'

export const Route = createRootRouteWithContext<RouteContext>()({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <Header />
      <Outlet />
      <TanStackRouterDevtools />
      <TanStackQueryLayout />
      <Toaster position="top-center" richColors />
    </>
  )
}
